import Spinner from 'react-bootstrap/Spinner';

function Loader() {
    return (
        <>
            <Spinner animation="border" size="sm" />
        </>
    );
}

export default Loader;